import cn from 'classnames';
import * as React from 'react';
import { useSelector } from 'react-redux';

import * as styles from './SidebarContainer.css';
import { selectIsDesktopListingVisible } from '../../../common/selectors/desktopListing';
import { Sidebar } from '../../components/Sidebar';
import { SIDEBAR_ANIMATION_DURATION } from '../../constants/animation';
import { ChatPopupContainer } from '../ChatPopupContainer';
import { ListingDesktopContainer } from '../ListingDesktopContainer';
import { ListingToggleButtonContainer } from '../ListingToggleButtonContainer/ListingToggleButtonContainer';

interface ISidebarContainerProps {
  onOfferMouseEnter?: (realtyId: number) => void;
  onOfferMouseLeave?: (realtyId: number) => void;
}

export const SidebarContainer: React.FC<ISidebarContainerProps> = ({ onOfferMouseEnter, onOfferMouseLeave }) => {
  const isVisible = useSelector(selectIsDesktopListingVisible);

  return (
    <>
      <div className={styles['stack']}>
        <div
          className={cn(styles['sidebar-wrapper'], isVisible && styles['sidebar-wrapper-opened'])}
          style={{ '--sidebar-animation-duration': `${SIDEBAR_ANIMATION_DURATION}ms` } as React.CSSProperties}
        >
          <Sidebar opened={isVisible}>
            <ListingDesktopContainer onOfferMouseEnter={onOfferMouseEnter} onOfferMouseLeave={onOfferMouseLeave} />
          </Sidebar>
        </div>
        <ListingToggleButtonContainer />
      </div>
      <ChatPopupContainer />
    </>
  );
};

SidebarContainer.displayName = 'SidebarContainer';
